/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ rank: NonNullable<unknown> }} Clubs_Standing_RowInputs */

const en_us2_clubs_standing_row = /** @type {(inputs: Clubs_Standing_RowInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`#${i?.rank}`)
};

const pt_br2_clubs_standing_row = /** @type {(inputs: Clubs_Standing_RowInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.rank}º`)
};

const es_419_clubs_standing_row = /** @type {(inputs: Clubs_Standing_RowInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`#${i?.rank}`)
};

const pt_pt2_clubs_standing_row = /** @type {(inputs: Clubs_Standing_RowInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`#${i?.rank}`)
};

const fr_fr2_clubs_standing_row = /** @type {(inputs: Clubs_Standing_RowInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`#${i?.rank}`)
};

const de_de2_clubs_standing_row = /** @type {(inputs: Clubs_Standing_RowInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`#${i?.rank}`)
};

const it_it2_clubs_standing_row = /** @type {(inputs: Clubs_Standing_RowInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`#${i?.rank}`)
};

/**
* | output |
* | --- |
* | "#{rank}" |
*
* @param {Clubs_Standing_RowInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const clubs_standing_row = /** @type {((inputs: Clubs_Standing_RowInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Clubs_Standing_RowInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_clubs_standing_row(inputs)
	if (locale === "es-419") return es_419_clubs_standing_row(inputs)
	if (locale === "pt-PT") return pt_pt2_clubs_standing_row(inputs)
	if (locale === "fr-FR") return fr_fr2_clubs_standing_row(inputs)
	if (locale === "de-DE") return de_de2_clubs_standing_row(inputs)
	if (locale === "it-IT") return it_it2_clubs_standing_row(inputs)
	return en_us2_clubs_standing_row(inputs)
});
export { clubs_standing_row as "clubs.standing_row" }